/**
 * Counterweight Component
 *
 * The sandbag that rises as the backdrop descends,
 * simulating a theatrical counterweight fly system.
 * Hidden on mobile viewports.
 */

import React from "react";
import { AnimationPhase, ASSETS } from "./constants";
import styles from "./WelcomeAnimation.module.css";

interface CounterweightProps {
  phase: AnimationPhase;
}

export function Counterweight({ phase }: CounterweightProps) {
  // Determine CSS class based on phase
  const phaseClass = styles[phase] || "";

  return (
    <div className={`${styles.counterweight} ${phaseClass}`}>
      <img src={ASSETS.SANDBAG} alt="" role="presentation" draggable={false} />
    </div>
  );
}
